export const APP_STATE_NAMESPACE = 'FLOATING_SUGGESTIONS';
